import React, { Component } from 'react';
import { Table, Popconfirm, message, Button, Input,Select } from 'antd';
import UpdateBusinessTrip from './UpdateBusinessTrip';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { Option } = Select;

class Filter extends Component {
    state = {
        searchParams: {
            workStatus: 'WORKING',
        },
    }

    search = () => {
        const {
            searchParams,
        } = this.state;
        this.props.search({ ...searchParams });
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }
    
    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    render() {
        const {
            searchParams: {
                employeeCode,
                userCompellation,
                workStatus,
                isAbroad
            }
        } = this.state;
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label htmlFor="" className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        value={userCompellation}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">是否驻外</label>
                    <Select
                        onChange={value => this.handleSelectChange(value, 'isAbroad')}
                        placeholder="请选择"
                        value={isAbroad}
                        style={{ width: 90 }}
                        allowClear={true}
                    >
                        <Option value="1">是</Option>
                        <Option value="0">否</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">状态</label>
                    <Select
                        onChange={value => this.handleSelectChange(value, 'workStatus')}
                        placeholder="请选择"
                        value={workStatus}
                        style={{width:90}}
                        allowClear={true}
                    >
                        <Option value="WORKING">在职</Option>
                        <Option value="LEFT">离职</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

class BusinessTrip extends Component {
    state = {
        data: [],
        sortParams: {},
        searchParams: {
            workStatus: 'WORKING',
        },
        pagination: {
            pageSize: 3,
            current: 1,
        },
        loading: false,
        expandedRowKeys: [],
        subList: {},
        role: {},
    }

    componentDidMount() {
        const { curRole } = sessionStorage;
        const role = {
            isVP: curRole == 'VP',
            isFIN: curRole == 'FIN',
        };
        this.setState({ role }, () => {
            this.loadData();
        })
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: params,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const params = {
            ...sortParams,
            ...searchParams,
            exportType: 'userStationedAbroad'
        }
        ExportUtil.export(params, pagination, API_URL.user.exportEmployeeList);
        message.success('人员短期驻外/出差开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出!')
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryDirectSubordinateList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                const expandedRowKeys = [];
                const values = Object.values(searchParams);
                if (values.some(i => !!i)) {
                    datas.forEach(i => expandedRowKeys.push(i.userId));
                }

                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                    expandedRowKeys,
                }, () => {
                    expandedRowKeys.forEach(i => this.loadSubData(i));
                });
            }
        };
        $.sendRequest(options);
    }

    loadSubData = (userId) => {
        const { searchParams } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserBusinessTravelByUserId,
            data: {
                ...searchParams,
                userId,
            },
            dataType: 'json',
            doneResult: res => {
                const { subList } = this.state;
                subList[userId] = res.list;
                this.setState({
                    subList,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    subDelete = (row) => {
        const { userId, userBusinessTravelId } = row;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.delUserBusinessTravel,
            data: { userBusinessTravelId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadSubData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }


    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            subList: {},
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    getDateRender = text => text ? text.slice(0, 10) : ''

    getColumns = () => {
        const { role: { isVP, isFIN } } = this.state;
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
            sorter: true,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 80,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
        }, {
            title: '手机号码',
            dataIndex: 'userMobile',
            key: 'userMobile',
        }, {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
            width: 180,
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            width: 100,
            render: (text, record) => {
                const { canSetAbroad } = record;
                return canSetAbroad ? <a onClick={() => this.updateBusinessTrip(record)}>设置驻外信息</a> : null;
            }
        }];
        return columns;
    }

    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => {
            const { workStatus } = item;
            return {
                index: (current - 1) * pageSize + index + 1,
                ...item,
                workStatus: workStatus ? (workStatus === 'WORKING' ? '在职' : "离职") : '',
            };
        });
        return dataSource;
    }

    onExpand = (expanded, record) => {
        const { expandedRowKeys } = this.state;
        if (expandedRowKeys.length == 0) {
            expandedRowKeys.push(record.userId);
        } else {
            if (expanded) {
                expandedRowKeys.push(record.userId);
            } else {
                expandedRowKeys.map((item, index) => {
                    if (item == record.userId) {
                        expandedRowKeys.splice(index, 1);
                    };
                });
            }
        }
        this.setState({ expandedRowKeys });
        if (expanded) {
            this.loadSubData(record.userId);
        }
    }

    expandedRowRender = (record) => {
        const { userId } = record;
        const { role: { isVP, isFIN }, subList } = this.state;
        const subData = subList[userId] || [];

        const getColumns = () => {
            const columns = [{
                title: '是否驻外',
                dataIndex: 'yesNo',
                key: 'yesNo',
                width: 175,
                render: (text, record) => {
                    const { yesNo } = record;
                    return yesNo ? '是' : '否'
                },
            }, {
                title: '驻外时间',
                dataIndex: 'abroadTime',
                key: 'abroadTime',
                width: 175,
            }, {
                title: '驻外医院',
                dataIndex: 'hospitalName',
                key: 'hospitalName',
                width: 175,
            }, {
                title: '驻外科室',
                dataIndex: 'departmentLocalName',
                key: 'departmentLocalName',
                width: 175,
            }];
            return columns;
        }
    
        const getDataSource = () => {
            const dataSource = [];
    
            if (subData && subData.length > 0) {
                subData.map((item, index) => {
                    dataSource.push({
                        index: index + 1,
                        ...item,
                    });
                });
            }
            return dataSource;
        };

        return (
            <Table
                rowKey={record => record.index}
                columns={getColumns()}
                dataSource={getDataSource()}
                pagination={false}
                scroll={{ x: 875, y: 300 }}
            />
        );
    }

    updateBusinessTrip = (parentParams, params) => {
        this.updateBusinessTripRef.show(parentParams, params);
    }

    render() {
        const { loading, pagination, expandedRowKeys } = this.state;
        return (
            <div>
                <Filter
                    search={this.search}
                    export={this.export}
                />
                <Table
                    loading={loading}
                    scroll={{ x: 955 }}
                    pagination={pagination}
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={record => record.userId}
                    onChange={this.handleTableChange}
                    onExpand={this.onExpand}
                    expandedRowKeys={expandedRowKeys}
                    expandedRowRender={this.expandedRowRender}
                />
                <UpdateBusinessTrip ref={el => this.updateBusinessTripRef = el} loadData ={this.loadSubData} />
            </div>
        );
    }
}

export default BusinessTrip;


// WEBPACK FOOTER //
// ./src/components/user/userInfo/BusinessTrip.js